import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchEphemeralExercises = (setEphemeralExercises: Function, setLoaded: Function, language: string) => {
  setLoaded(false);

  ApiService.get("ephemeral-evaluations/exercises")
    .then((response) => setEphemeralExercises(response.data.ephemeral_exercises))
    .catch((error) => {
      console.error("Error fetching ephemeral evaluation exercises:", error);
      alert(translate(language, "PAGES.EPHEMERAL_EXERCISES.ERRORS.FETCH"));
    })
    .finally(() => setLoaded(true));
};
